/**
 * The admin panel's own login — a separate screen for a separate cookie.
 *
 * Reuses the studio login's visual language (same CSS classes) but shares no
 * code with it: this posts to /api/platform/login, not /api/auth/login, and
 * nothing here ever touches the studio SessionContext. Confusing the two
 * would be exactly the mistake migration 0017 exists to make impossible.
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiError, api } from '../api/client.js';
import { messageFor } from '../api/error-messages.js';
import { Button } from '../components/ui/Button.js';
import { Field } from '../components/ui/Field.js';
import './Login.css';

export function PlatformLogin() {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(undefined);

    try {
      await api.post('/api/platform/login', { username, password });
      navigate('/yonetim', { replace: true });
    } catch (err) {
      setError(
        err instanceof ApiError ? messageFor(err.code) : messageFor('INTERNAL_ERROR'),
      );
      setPassword('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <div className="login__card">
        <div className="login__brand">
          <span className="login__brand-name">Trackpil</span>
          <span className="login__brand-tagline">Yönetim Paneli</span>
        </div>

        <form onSubmit={submit} className="login__form" noValidate>
          <Field
            label="Kullanıcı adı"
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <Field
            label="Şifre"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={error}
            required
          />

          <Button type="submit" loading={busy}>
            {busy ? 'Giriş yapılıyor…' : 'Giriş Yap'}
          </Button>
        </form>
      </div>
    </main>
  );
}
